import React from 'react';

import { MAX_SHOW_PAGING_PAGE } from '../../constants/constants';

class PageTablePagination extends React.Component {
  shouldComponentUpdate(nextProps) {
    const { page, numberOfPage } = this.props;
    return nextProps.page !== page || nextProps.numberOfPage !== numberOfPage;
  }

  componentDidUpdate() {
    const { page, numberOfPage, onChangePage } = this.props;
    if (numberOfPage < page) {
      onChangePage(1);
    }
  }

  genArrayPageNumber = () => {
    const { page, numberOfPage } = this.props;
    const maxShowingPage = Math.min(numberOfPage, MAX_SHOW_PAGING_PAGE);
    const middle = parseInt(maxShowingPage / 2, 10);
    const pageItems = [...Array(maxShowingPage).keys()].map(
      index => index - middle + page,
    );
    if (pageItems[0] < 1) {
      return pageItems.map(item => item + 1 - pageItems[0]);
    } else if (pageItems[pageItems.length - 1] > numberOfPage) {
      return pageItems.map(
        item => item - pageItems[pageItems.length - 1] + numberOfPage,
      );
    }
    return pageItems;
  };

  render() {
    const { page, numberOfPage, onChangePage } = this.props;

    const enablePaging = numberOfPage >= page;

    return (
      <ul className="pagination">
        <li onClick={() => enablePaging && page > 1 && onChangePage(1)}>
          <span>
            <i className="fas fa-angle-double-left" />
          </span>
        </li>
        <li onClick={() => enablePaging && page > 1 && onChangePage(page - 1)}>
          <span>
            <i className="fas fa-angle-left" />
          </span>
        </li>
        {this.genArrayPageNumber().map(pageNumber => (
          <li
            key={pageNumber}
            onClick={() => page !== pageNumber && onChangePage(pageNumber)}
          >
            <span className={`${page === pageNumber ? 'active' : ''}`}>
              {pageNumber}
            </span>
          </li>
        ))}
        <li
          onClick={() =>
            enablePaging && page < numberOfPage && onChangePage(page + 1)
          }
        >
          <span>
            <i className="fas fa-angle-right" />
          </span>
        </li>
        <li
          onClick={() =>
            enablePaging && page < numberOfPage && onChangePage(numberOfPage)
          }
        >
          <span>
            <i className="fas fa-angle-double-right" />
          </span>
        </li>
      </ul>
    );
  }
}

export default PageTablePagination;



// WEBPACK FOOTER //
// ./foody/src/components/Table/PageTablePagination.jsx